/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Button, Checkbox, CircularProgress, FormControl, InputLabel, OutlinedInput, styled, TextField, Tooltip, Typography } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { showNotification } from "../../../common/Notification/ToastifyNotification";
import { Actions, tableNames } from "../../../common/const";
import moment from "moment";
import { useSelector } from "react-redux";
import { apiRequest } from "../../../common/common";
import { LoadingPage } from "../../../common/LoadingPage";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const CustomFilterPanelWrapper = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: 10,
});

const FilterContent = styled(Box)({
    flexGrow: 1,
    overflowY: 'auto',
    paddingBottom: 30,
});

const FilterFooter = styled(Box)({
    position: 'sticky',
    bottom: 0,
    display: 'flex',
    gap: 5
});

const FixedButton = styled(Button)({
    width: '100%',
});

export default function HistoryFilterPanel({ projectId, applyFilter }) {
    const { users } = useSelector(state => state.users);
    const [expanded, setExpanded] = useState(false);
    const [filters, setFilters] = useState(localStorage.getItem('auditfilters') ? JSON.parse(localStorage.getItem('auditfilters')) : {});
    const [depData, setDepData] = useState([]);
    const [roomData, setRoomData] = useState([]);
    const [buildingData, setBuildingData] = useState([]);
    const [levelData, setLevelData] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);

    // Separate tracking arrays for each dropdown
    const [selectedRooms, setSelectedRooms] = useState([]);
    const [selectedDepartments, setSelectedDepartments] = useState([]);
    const [selectedLevels, setSelectedLevels] = useState([]);
    const [selectedBuildings, setSelectedBuildings] = useState([]);

    // Merge all 4 selected IDs into filters.recordId as comma-separated string
    const mergeRecordIds = (rooms, departments, levels, buildings) => {
        const allIds = [
            ...rooms,
            ...departments,
            ...levels,
            ...buildings,
        ].filter(Boolean);

        setFilters((prevData) => ({
            ...prevData,
            recordId: allIds.join(','),
        }));
    };

    const getRooms = async () => {
        const url = [
            `/project-room?projectId=${projectId}`,
            `pageNo=1`,
            `pageSize=100`,
        ].filter(Boolean).join('&');
        try {
            const response = await apiRequest('get', `${url}`);
            const { data } = response.data;
            setRoomData(data);
            setDataLoading(false);
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    const getDepartment = async () => {
        const url = [
            `/department?projectId=${projectId}`,
            `pageNo=1`,
            `pageSize=100`,
        ].filter(Boolean).join('&');
        try {
            const response = await apiRequest('get', `${url}`);
            const { data } = response.data;
            setDepData(data);
            setDataLoading(false);
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    const getBuilding = async () => {
        setDataLoading(true);
        const url = [
            `/building?projectId=${projectId}`,
            `pageNo=1`,
            `pageSize=100`,
        ].filter(Boolean).join('&');
        try {
            const response = await apiRequest('get', `${url}`);
            const { data } = response.data;
            setBuildingData(data);
            setDataLoading(false);
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    const getLevel = async () => {
        setDataLoading(true);
        const url = [
            `/level?projectId=${projectId}`,
            `pageNo=1`,
            `pageSize=100`,
        ].filter(Boolean).join('&');
        try {
            const response = await apiRequest('get', `${url}`);
            const { data } = response.data;
            setLevelData(data);
            setDataLoading(false);
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    const handleChange = (panel) => (event, isExpanded) => {
        if (panel === 'panel1' && isExpanded) {
            const obj = filters;
            if (!obj?.tableName) {
                obj.tableName = [];
            }
            setFilters(obj);
        }
        if (panel === 'panel2' && isExpanded) {
            const obj = filters;
            if (!obj?.action) {
                obj.action = [];
            }
            setFilters(obj);
        }
        if (panel === 'panel3' && isExpanded) {
            const obj = filters;
            if (!obj?.startdate) {
                obj.startdate = null;
            }
            if (!obj?.enddate) {
                obj.enddate = null;
            }
            setFilters(obj);
        }
        if (panel === 'panel4' && isExpanded) {
            const obj = filters;
            if (!obj?.objectName) {
                obj.objectName = null;
            }
            setFilters(obj);
        }
        if (panel === 'panel5' && isExpanded) {
            const obj = filters;
            if (!obj?.userId) {
                obj.userId = [];
            }
            setFilters(obj);
        }
        if (panel === 'panel6' && isExpanded) {
            const obj = filters;
            getRooms();
            getDepartment();
            getLevel();
            getBuilding();
            if (!obj?.recordId) {
                obj.recordId = '';
            }
            setFilters(obj);
        }
        setExpanded(isExpanded ? panel : false);
    };

    const handleFilter = async () => {
        if (filters?.tableName?.length === 0) {
            showNotification('Please select Object Type', 'error');
        } else if (filters?.action === null) {
            showNotification('Please select Action', 'error');
        } else if (filters?.startdate === null || filters?.enddate === null) {
            showNotification('Please select Date Range', 'error');
        } else if (filters?.objectName === null) {
            showNotification('Please enter Object Name', 'error');
        } else if (filters?.userId?.length === 0) {
            showNotification('Please select Action By', 'error');
        } else if (!filters?.recordId && filters?.recordId === '') {
            showNotification('Please select at least one Object Location (Room, Department, Level, or Building)', 'error');
        } else {
            setExpanded(false);
            await applyFilter(filters);
        }
    }

    return (
        <CustomFilterPanelWrapper>
            {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
            <Typography variant="body1" style={{ fontWeight: 'bold' }}>Filters</Typography>
            <FilterContent>

                {/* Action Filter */}
                <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2-content"
                        id="panel2-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {filters?.action?.length > 0 && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Action</Typography>
                            </Box>
                            {expanded === 'panel2' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.action;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Autocomplete
                            value={Actions.find((c) => filters?.action === c.value)}
                            id="checkboxes-tags-demo"
                            size="small"
                            fullWidth
                            clearIcon={true}
                            disableCloseOnSelect
                            options={Actions}
                            getOptionLabel={(option) => option?.label}
                            onChange={(event, newValue) => {
                                setFilters((prevData) => ({
                                    ...prevData,
                                    action: newValue.value,
                                }));
                            }}
                            renderInput={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                    label="Action"
                                    name="Action"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />}
                        />
                    </AccordionDetails>
                </Accordion>

                {/* Action By Filter */}
                <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel5-content"
                        id="panel5-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {filters?.userId?.length > 0 && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Action By</Typography>
                            </Box>
                            {expanded === 'panel5' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.userId;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Autocomplete
                            value={users.filter((c) => filters?.userId?.includes(c.user_id)) || []}
                            id="checkboxes-tags-demo"
                            size="small"
                            fullWidth
                            multiple
                            clearIcon={true}
                            disableCloseOnSelect
                            options={users}
                            getOptionLabel={(option) => `${option?.first_name} ${option?.last_name !== null ? option?.last_name : ''}`}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {`${option?.first_name} ${option?.last_name !== null ? option?.last_name : ''}`}
                                    </li>
                                );
                            }}
                            onChange={(event, newValue) => {
                                setFilters((prevData) => ({
                                    ...prevData,
                                    userId: newValue.map((a) => a.user_id),
                                }));
                            }}
                            renderInput={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                    label="Action By"
                                    name="Action By"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />}
                        />
                    </AccordionDetails>
                </Accordion>

                {/* Date Range Filter */}
                <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel3-content"
                        id="panel3-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {(filters?.startdate && filters?.enddate) && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Date Range</Typography>
                            </Box>
                            {expanded === 'panel3' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.startdate;
                                            delete obj.enddate;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password" shrink={filters?.startdate === null || filters?.startdate === '' || filters?.startdate}>Date 1</InputLabel>
                            <OutlinedInput
                                label="Date 1"
                                id="Date 1"
                                type='date'
                                value={filters?.startdate || ''}
                                onChange={(e) => {
                                    setFilters((prevData) => ({
                                        ...prevData,
                                        startdate: moment(e.target.value).format('YYYY-MM-DD') || null,
                                    }));
                                }}
                            />
                        </FormControl>
                        <FormControl size="small" fullWidth variant="outlined" style={{ marginTop: 15 }}>
                            <InputLabel htmlFor="standard-adornment-password" shrink={filters?.enddate === null || filters?.enddate === '' || filters?.enddate}>Date 2</InputLabel>
                            <OutlinedInput
                                label="Date 2"
                                id="Date 2"
                                type='date'
                                value={filters?.enddate || ''}
                                onChange={(e) => {
                                    setFilters((prevData) => ({
                                        ...prevData,
                                        enddate: moment(e.target.value).format('YYYY-MM-DD') || null,
                                    }));
                                }}
                            />
                        </FormControl>
                    </AccordionDetails>
                </Accordion>

                {/* Object Type Filter */}
                <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {filters?.tableName?.length > 0 && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Object Type</Typography>
                            </Box>
                            {expanded === 'panel1' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.tableName;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Autocomplete
                            value={tableNames.filter((c) => filters?.tableName?.includes(c.value)) || []}
                            id="checkboxes-tags-demo"
                            size="small"
                            fullWidth
                            multiple
                            clearIcon={true}
                            disableCloseOnSelect
                            options={tableNames}
                            getOptionLabel={(option) => option?.label}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.label}
                                    </li>
                                );
                            }}
                            onChange={(event, newValue) => {
                                setFilters((prevData) => ({
                                    ...prevData,
                                    tableName: newValue.map((a) => a.value),
                                }));
                            }}
                            renderInput={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                    label="Object Type"
                                    name="Object Type"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />}
                        />
                    </AccordionDetails>
                </Accordion>

                {/* Object Name Filter */}
                <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel4-content"
                        id="panel4-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {filters?.objectName && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Object Name</Typography>
                            </Box>
                            {expanded === 'panel4' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.objectName;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Object Name</InputLabel>
                            <OutlinedInput
                                label="Object Name"
                                id="objectname"
                                type='text'
                                value={filters?.objectName || ''}
                                onChange={(e) => {
                                    setFilters((prevData) => ({
                                        ...prevData,
                                        objectName: e.target.value,
                                    }));
                                }}
                            />
                        </FormControl>
                    </AccordionDetails>
                </Accordion>

                {/* Object Location Filter */}
                <Accordion expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel6-content"
                        id="panel6-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {filters?.recordId && filters?.recordId !== '' && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Object Location</Typography>
                            </Box>
                            {expanded === 'panel6' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = { ...filters };
                                            delete obj.recordId;
                                            setFilters(obj);
                                            setSelectedRooms([]);
                                            setSelectedDepartments([]);
                                            setSelectedLevels([]);
                                            setSelectedBuildings([]);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>

                        {/* Room */}
                        <Autocomplete
                            value={selectedRooms}
                            size="small"
                            fullWidth
                            multiple
                            clearIcon={true}
                            disableCloseOnSelect
                            options={roomData}
                            getOptionLabel={(option) => `${option?.room_name} ${option.room_no ? `(${option.room_no})` : ''}`}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {`${option?.room_name} ${option.room_no ? `(${option.room_no})` : ''}`}
                                    </li>
                                );
                            }}
                            onChange={(event, newValue) => {
                                setSelectedRooms(newValue);
                                const roomIds = newValue.map((a) => a.room_id);
                                mergeRecordIds(
                                    roomIds,
                                    selectedDepartments.map(a => a.department_id),
                                    selectedLevels.map(a => a.level_id),
                                    selectedBuildings.map(a => a.building_id)
                                );
                            }}
                            renderInput={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                    label="Room"
                                    name="Room"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {dataLoading ? <CircularProgress color="primary" size={20} /> : null}
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />}
                        />
                        <br />

                        {/* Department */}
                        <Autocomplete
                            value={selectedDepartments}
                            size="small"
                            fullWidth
                            multiple
                            clearIcon={true}
                            disableCloseOnSelect
                            options={depData}
                            getOptionLabel={(option) => option?.department_name}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.department_name}
                                    </li>
                                );
                            }}
                            onChange={(event, newValue) => {
                                setSelectedDepartments(newValue);
                                const depIds = newValue.map((a) => a.department_id);
                                mergeRecordIds(
                                    selectedRooms.map(a => a.room_id),
                                    depIds,
                                    selectedLevels.map(a => a.level_id),
                                    selectedBuildings.map(a => a.building_id)
                                );
                            }}
                            renderInput={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                    label="Department"
                                    name="Department"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {dataLoading ? <CircularProgress color="primary" size={20} /> : null}
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />}
                        />
                        <br />

                        {/* Level */}
                        <Autocomplete
                            value={selectedLevels}
                            size="small"
                            fullWidth
                            multiple
                            clearIcon={true}
                            disableCloseOnSelect
                            options={levelData}
                            getOptionLabel={(option) => option?.level_name}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.level_name}
                                    </li>
                                );
                            }}
                            onChange={(event, newValue) => {
                                setSelectedLevels(newValue);
                                const levelIds = newValue.map((a) => a.level_id);
                                mergeRecordIds(
                                    selectedRooms.map(a => a.room_id),
                                    selectedDepartments.map(a => a.department_id),
                                    levelIds,
                                    selectedBuildings.map(a => a.building_id)
                                );
                            }}
                            renderInput={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                    label="Level"
                                    name="Level"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />}
                        />
                        <br />

                        {/* Building */}
                        <Autocomplete
                            value={selectedBuildings}
                            size="small"
                            fullWidth
                            multiple
                            clearIcon={true}
                            disableCloseOnSelect
                            options={buildingData}
                            getOptionLabel={(option) => option?.building_name}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.building_name}
                                    </li>
                                );
                            }}
                            onChange={(event, newValue) => {
                                setSelectedBuildings(newValue);
                                const buildingIds = newValue.map((a) => a.building_id);
                                mergeRecordIds(
                                    selectedRooms.map(a => a.room_id),
                                    selectedDepartments.map(a => a.department_id),
                                    selectedLevels.map(a => a.level_id),
                                    buildingIds
                                );
                            }}
                            renderInput={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                    label="Building"
                                    name="Building"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />}
                        />

                    </AccordionDetails>
                </Accordion>

            </FilterContent>
            <FilterFooter>
                <FixedButton variant="outlined" color="secondary" onClick={() => {
                    applyFilter({});
                    setFilters({});
                    setSelectedRooms([]);
                    setSelectedDepartments([]);
                    setSelectedLevels([]);
                    setSelectedBuildings([]);
                    setExpanded(false);
                    localStorage.removeItem('auditfilters');
                }}>Clear</FixedButton>
                <FixedButton variant="outlined" color="primary" onClick={() => handleFilter()}>Apply</FixedButton>
            </FilterFooter>
        </CustomFilterPanelWrapper>
    )
}